<template>
  <small-modal v-if="modelValue" @modalClose="close">
    <template v-slot:header> Trade Experience Settings </template>
    <template v-slot:content>
      <div class="market-settings-modal__menu">
        <div
          v-for="setting in settingsModalOptions"
          :key="setting.key"
          class="market-settings-modal__option"
        >
          <div class="market-settings-modal__label">
            {{ setting.info }}
          </div>
          <div class="market-settings-modal__inner">
            <div class="market-settings-modal__inner-items">
              <div
                v-for="option in setting.options"
                :key="option.key"
                class="market-settings-modal__inner-item"
                :class="{
                  'market-settings-modal__inner-item--selected': isSelected(
                    setting.key,
                    option.key,
                  ),
                  'market-settings-modal__inner-item--disabled': isOptionDisabled(option),
                }"
                @click.prevent.stop="onSettingOptionClick(setting.key, option)"
              >
                {{ option.info }}
              </div>
            </div>
          </div>
        </div>
        <hr />
        <button class="button button--large button--black button--full-width" @click="close">
          Close
        </button>
      </div>
    </template>
  </small-modal>
</template>

<script src="./market-settings-modal.js"></script>
<style src="./market-settings-modal.scss" lang="scss"></style>
